import { render, staticRenderFns } from "./serviceCancel.vue?vue&type=template&id=01ee4f36&scoped=true"
import script from "./serviceCancel.vue?vue&type=script&lang=js"
export * from "./serviceCancel.vue?vue&type=script&lang=js"
import style0 from "./serviceCancel.vue?vue&type=style&index=0&id=01ee4f36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ee4f36",
  null
  
)

export default component.exports